import React, { useMemo } from 'react';
import StyledBox from 'views/membership-module/MembershipView/components/WhyChooseSubscriptionSection/WhyChooseSubscriptionSection.styles';
import { useTranslation } from 'next-i18next';
import { Grid, Box, Typography } from '@mui/material';
import { Typography700 } from 'views/common/components';
import Plans from 'views/common/components/UI/Icons/riderTen/Plans';
import Interest from 'views/common/components/UI/Icons/riderTen/Interest';
import Inclusive from 'views/common/components/UI/Icons/riderTen/Inclusive';
import Safety from 'views/common/components/UI/Icons/riderTen/Safety';
import WorldWide from 'views/common/components/UI/Icons/riderTen/WorldWide';
import Brands from 'views/common/components/UI/Icons/riderTen/Brands';

const WhyChooseSubscriptionSection = () => {
  const { t } = useTranslation('fe_er_membership_page');
  const benfites = useMemo(
    () => [
      {
        title: t('fe_er_membership_page:affordable_monthly_plans'),
        desc: t('fe_er_membership_page:affordable_monthly_plans_desc'),
        icon: <Plans className="WCSSIcon" />,
      },
      {
        title: t('fe_er_membership_page:zero_hassles_interest'),
        desc: t('fe_er_membership_page:zero_hassles_interest_desc'),
        icon: <Interest className="WCSSIcon" />,
      },
      {
        title: t('fe_er_membership_page:all_inclusive'),
        desc: t('fe_er_membership_page:all_inclusive_desc'),
        icon: <Inclusive className="WCSSIcon" />,
      },
      {
        title: t('fe_er_membership_page:safety_guaranteed'),
        desc: t('fe_er_membership_page:safety_guaranteed_desc'),
        icon: <Safety className="WCSSIcon WCSSIconFill" />,
      },
      {
        title: t('fe_er_membership_page:ride_anywhere'),
        desc: t('fe_er_membership_page:ride_anywhere_desc'),
        icon: <WorldWide className="WCSSIcon WCSSIconFill" />,
      },
      {
        title: t('fe_er_membership_page:top_brands'),
        desc: t('fe_er_membership_page:top_brands_desc'),
        icon: <Brands className="WCSSIcon WCSSIconFill" />,
      },
    ],
    [],
  );
  return (
    <StyledBox>
      <Grid container spacing={{ lg: 6, sm: 3 }}>
        {benfites.map((item) => (
          <Grid item xl={4} lg={6} md={12} sm={12} key={item.title}>
            <Box className="WCSSIconCard">
              {item.icon}
              <Typography700 variant="h3" className="WCSSTitle">
                {item.title}
              </Typography700>
              <Typography variant="body1">{item.desc}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </StyledBox>
  );
};

export { WhyChooseSubscriptionSection };
